import React, { useContext, useEffect, useState } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import withForm from 'modules/common/hoc/withForm';
import Modal from 'modules/common/components/Modal';
import PropTypes from 'prop-types';
import { ModalContext } from 'App';
import useFormValidator from 'useFormValidator';
import Select from 'react-select';
import { customStyle } from 'helper';
import * as actions from '../action';
import * as c from '../constant';

function StreetModal({
  createStreet,
  getStreetList,
  history,
  getSingleStreet,
  locationList,
  getLocationList,
  type,
  updateStreet,
  updateList,
  streetId,
}) {
  const [formData, setFormData] = useState({
    name: '',
    code: '',
    rptax_location_id: '',
  });
  const validateForm = useFormValidator(formData, {
    name: 'required',
    code: 'required',
    rptax_location_id: 'required',
  });

  useEffect(() => {
    getLocationList();
  }, []);

  const setModal = useContext(ModalContext);

  const onChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleOnSubmit = (e) => {
    e.preventDefault();

    if (type === 'NEW') {
      createStreet(formData, ({ data }) => {
        setModal({ isOpen: false });
        getStreetList();
        history.push(
          `/rpt/settings/property-locations/streets/${_.get(data, 'id')}`
        );
        getSingleStreet(data.id);
      });
    }

    if (type === 'EDIT') {
      updateStreet(streetId, formData, ({ data }) => {
        setModal({ isOpen: false });
        getStreetList();
        history.push(
          `/rpt/settings/property-locations/streets/${_.get(data, 'id')}`
        );
        getSingleStreet(data.id);
      });
    }


  };

  const closeModal = (e) => {
    e.preventDefault();
    setModal({ isOpen: false });
  };

  useEffect(() => {
    validateForm.validate();
  }, [Object.values(formData).join(',')]);

  const onSetFormData = () => {
    if (!_.isEmpty(updateList)) {
      const args = {
        ...updateList,
      };
      setFormData(_.pick(args, _.keys(c.FORM_DATA)));
    }
  };

  useEffect(() => {
    if (type === 'EDIT') {
      onSetFormData();
    }
  }, []);

  const locationOptions = locationList.map(x => ({
    label: _.get(x, 'attributes.name'),
    value: x.id,
    id: x.id,
  }));

  const handleSelected = key => (e) => {
    setFormData({
      ...formData,
      [key]: e.value,
    });
  };

  return (
    <Modal.Body>
      <form onSubmit={handleOnSubmit}>
        <div className="row">
          <div className="col-12 form-group">
            <label htmlFor="last_name" className="full-label mb-0">
              Code {validateForm.renderMessage('code')}
            </label>
            <input
              className="form-control"
              type="number"
              name="code"
              onChange={onChange}
              value={_.get(formData, 'code')}
            />
          </div>
          <div className="col-12 form-group">
            <label htmlFor="last_name" className="full-label mb-0">
              Name {validateForm.renderMessage('name')}
            </label>
            <input
              className="form-control"
              type="text"
              name="name"
              onChange={onChange}
              value={_.get(formData, 'name')}
            />
          </div>
          <div className="col-12 form-group">
            <label className="form-label">Location
              &nbsp; {validateForm.renderMessage('rptax_location_id')}
            </label>
            <div>
              <Select
                options={locationOptions}
                styles={customStyle}
                placeholder="Select Location"
                value={locationOptions.filter(item => +_.get(formData, 'rptax_location_id') === +_.get(item, 'id')) || ''}
                onChange={handleSelected('rptax_location_id')}
              />
            </div>
          </div>
        </div>
        <div className="d-flex justify-content-center">
          <button
            disabled={!validateForm.response.is_passed}
            type="submit"
            className="mt-3 btn btn-primary mr-3"
          >
            <span className="font-weight-bold">
              Submit
            </span>
          </button>
          <button
            type="button"
            onClick={closeModal}
            className="mt-3 btn btn-dark "
          >
            <span className="font-weight-bold">Cancel</span>
          </button>
        </div>
      </form>
    </Modal.Body>
  );
}

StreetModal.defaultProps = {
  type: '',
  updateList: {},
  streetId: '',
}

StreetModal.propTypes = {
  type: PropTypes.string,
  streetId: PropTypes.string,
  updateList: PropTypes.instanceOf(Object),
  getStreetList: PropTypes.instanceOf(Function).isRequired,
  createStreet: PropTypes.instanceOf(Function).isRequired,
  updateStreet: PropTypes.instanceOf(Function).isRequired,
  history: PropTypes.instanceOf(Object).isRequired,
  getSingleStreet: PropTypes.instanceOf(Function).isRequired,
  getLocationList: PropTypes.instanceOf(Function).isRequired,
  locationList: PropTypes.instanceOf(Array).isRequired,
};

const mapStateToProps = ({ api }) => ({
  locationList: _.get(api, `${c.GET_LOCATION_LIST}.list`) || [],
});

const enhance = _.flowRight([
  withForm,
  withRouter,
  connect(mapStateToProps, {
    ...actions,
  }),
]);

export default enhance(StreetModal);
